import { render, staticRenderFns } from "./currency-record.vue?vue&type=template&id=2bf54222&scoped=true&"
import script from "./currency-record.vue?vue&type=script&lang=js&"
export * from "./currency-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf54222",
  null
  
)

export default component.exports